export enum ErrorTypes {
  UPDATE_SOURCES_TYPE = 'UPDATE_SOURCES_TYPE',
  CHECKING_FOR_CHANGES_ERROR_TYPE = 'CHECKING_FOR_CHANGES_ERROR_TYPE',
  ARTIFACT_DEPENDENCY_ERROR_TYPE = 'ARTIFACT_DEPENDENCY_ERROR_TYPE',
  PREPARATION_FAILURE_TYPE = 'PREPARATION_FAILURE_TYPE',
  DIRECTORY_CREATION_ERROR_TYPE = 'DIRECTORY_CREATION_ERROR_TYPE',
  BUILD_RUNNER_ERROR_TYPE = 'BUILD_RUNNER_ERROR_TYPE',
  TC_EXIT_CODE = 'TC_EXIT_CODE',
  SNAPSHOT_DEPENDENCY_ERROR = 'SNAPSHOT_DEPENDENCY_ERROR',
  SNAPSHOT_DEPENDENCY_ERROR_BUILD_PROCEEDS_TYPE = 'SNAPSHOT_DEPENDENCY_ERROR_BUILD_PROCEEDS_TYPE',
  TC_USER_PROVIDED = 'TC_USER_PROVIDED',
  TC_FAILED_TESTS = 'TC_FAILED_TESTS',
}
